// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2Cklr","col":"CardReaderDesc_col__1VxpC","label":"CardReaderDesc_label__3WFA7"};